import { createContext, useContext } from 'react';

export type ScreenLayoutValue = {
  headerHeight: number;
  footerHeight: number;
  /**
   * The padding-bottom reserved on the ScrollView's content. Inline content
   * that should never cause the page to scroll (e.g. an Autocomplete dropdown)
   * subtracts this from the viewport height to find its own max height.
   */
  scrollContentPaddingBottom: number;
};

export const ScreenLayoutContext = createContext<ScreenLayoutValue>({
  headerHeight: 0,
  footerHeight: 0,
  scrollContentPaddingBottom: 0,
});

/**
 * Exposes the header/footer overlay heights to descendants so floating UI
 * (e.g. an Autocomplete dropdown) can size itself against the visible content
 * region rather than overflowing under a sticky footer.
 */
export function useScreenLayout() {
  return useContext(ScreenLayoutContext);
}
